
export class Config {

    static organizationId = '67eab8a369ffab0df0ca4fee';
    static organizationName = "@mod-appname";
    static appVersion = '1.00.26';

    static cipher: string = 'KPdzpXFGaUkAFHwj5FBy82B6'; 

    static isCanuucan = 'false';

    static pickupTypes = [ 'DELIVERYTYPE08' ];

    constructor() { }
}
